import { Button, withStyles } from "@material-ui/core";

export const MobileReverseButton = withStyles((theme) => ({
    root: {
      color: theme.palette.secondary.main,
      backgroundColor: '#FFF',
      '&:hover': {
        backgroundColor: '#FFF',
      },
    },
  }))(Button);